import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../redux/authSlice';
import axios from '../api/axios';

const INVITE_REDEEM_URL = '/invite/redeem';

const InviteRedeem = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {

        const token = searchParams.get('token');

        if (!token) {
            setErrMsg('This invitation link is invalid.');
            return;
        }

        const redeem = async () => {
            try {
                const response = await axios.post(
                    INVITE_REDEEM_URL,
                    JSON.stringify({ token }),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );

                const {
                    email, userId, accessToken, isAdmin, surveyId,
                    profileComplete, invitationSourced,
                    showBenchmarkingTour, showInsightsTour,
                    showInvitedUserProfileDialog
                } = response.data;

                dispatch(setCredentials({
                    email,
                    userId,
                    isAdmin,
                    accessToken,
                    profileComplete,
                    invitationSourced,
                    showBenchmarkingTour,
                    showInsightsTour,
                    showInvitedUserProfileDialog
                }));

                navigate(`/insights/${surveyId}`, { replace: true });

            } catch (err) {
                if (!err?.response) {
                    setErrMsg('No server response. Please try again later.');
                } else if (err.response?.status === 401) {
                    setErrMsg(err.response?.data?.error || 'This invitation link is invalid or has expired.');
                } else {
                    setErrMsg('Something went wrong. Please try again later.');
                }
            }
        };

        redeem();

    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <section style={{ textAlign: 'center', marginTop: '40vh' }}>
            {errMsg
                ? <p className="errmsg">{errMsg}</p>
                : <p>Validating your invitation, please wait...</p>
            }
        </section>
    );
};

export default InviteRedeem;